import * as React from 'react';

function SvgGithub(props) {
    return (
        <svg width={33} height={33} viewBox="0 0 33 33" {...props}>
            <path
                d="M16.42.442C7.413.442.108 7.78.108 16.83a16.385 16.385 0 0011.156 15.551c.814.152 1.078-.356 1.078-.788v-3.051c-4.538.991-5.482-1.934-5.482-1.934-.743-1.894-1.812-2.398-1.812-2.398-1.48-1.018.112-.996.112-.996 1.638.115 2.5 1.69 2.5 1.69 1.455 2.504 3.816 1.78 4.747 1.361.146-1.058.568-1.782 1.036-2.19-3.623-.417-7.432-1.822-7.432-8.1 0-1.79.638-3.252 1.68-4.4-.168-.413-.727-2.08.16-4.337 0 0 1.37-.44 4.487 1.68 1.3-.363 2.695-.545 4.082-.552 1.387.007 2.783.189 4.086.552 3.115-2.12 4.482-1.68 4.482-1.68.888 2.258.329 3.925.16 4.338 1.047 1.147 1.68 2.61 1.68 4.399 0 6.294-3.816 7.68-7.449 8.086.585.508 1.12 1.505 1.12 3.035v4.497c0 .436.26.948 1.088.787a16.386 16.386 0 0011.145-15.55C32.732 7.78 25.428.44 16.42.44z"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default SvgGithub;
